import { Suspense, ReactNode } from 'react';
import { LoadingSpinner } from '../LoadingSpinner';

export interface ModalSuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Suspense wrapper for lazy-loaded modals
 * Displays loading spinner while modal component loads
 */
export function ModalSuspense({ children, fallback }: ModalSuspenseProps) {
  const defaultFallback = (
    <div className="flex items-center justify-center min-h-[200px]">
      <LoadingSpinner size="lg" />
    </div>
  );

  return (
    <div data-tsx-id="modal-suspense">
      <Suspense fallback={fallback || defaultFallback}>
        {children}
      </Suspense>
    </div>
  );
}
